import styles from "./cursor.module.scss"


export default function Cursor() {
    return (
      <svg
        viewBox="8 4 8 16"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.cursor}
      >
        <rect x="10" y="2" width="4" height="20" />
      </svg>
    );
  }